import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Avatar } from './Avatar';
import { Button } from './ui/Button';
import { useLocale } from '../contexts/LocaleContext';
import { useSocial } from '../contexts/SocialContext';
import type { PublicUser } from '../types';
export function PersonRow({
  person,
  showFollow = true
}: {
  person: PublicUser;
  showFollow?: boolean;
}) {
  const {
    t,
    tl
  } = useLocale();
  const navigate = useNavigate();
  const social = useSocial();
  const following = social.isFollowing(person.id);
  const open = () => navigate(`/u/${person.username.replace('@', '')}`);
  return <li className="flex items-center gap-2 border-b border-sand-line py-2 last:border-b-0" data-id="element-1220" data-mp="3bh9wxvop7q0r">
      <Avatar src={person.avatar} name={person.name} size={44} onClick={open} label={person.name} data-id="element-1221" data-mp="3fj4v4rbc1nab" />
      <button type="button" onClick={open} className="min-w-0 flex-1 text-left" data-id="element-1222" data-mp="720b8drgx62o">
        <p className="bee-overline text-[9px] font-bold text-gold-deep" data-id="element-1223" data-mp="bwo5kt95kup6">
          {t(`category.${person.category}`)} · {t('post.streak', {
          n: person.streak
        })}
        </p>
        <p className="mt-[2px] truncate text-[13.5px] font-medium text-deep" data-id="element-1224" data-mp="yqbkoq778o5z">
          {person.name}
        </p>
        <p className="truncate text-[11.5px] leading-snug text-muted" data-id="element-1225" data-mp="1dfhiqauaw8ca">
          {tl(person.bio)}
        </p>
      </button>
      {showFollow && person.id !== 'me' && <Button variant={following ? 'outline' : 'primary'} onClick={() => social.toggleFollow(person.id)} className="shrink-0" data-id="element-1226" data-mp="1mcrqvnbtnhcz">
          {following ? t('profile.following') : t('profile.follow')}
        </Button>}
    </li>;
}